import { capitalize } from '@plato/shared-util/strings';
import { useResolvedLocale } from '@plato/ui-legacy/lib/hooks/locale';
import { intlFormatDistance } from 'date-fns';

type MinimumUnit = 'minute' | 'day';

type FromNowProps = {
    date?: string | number | Date | null;
    children?: string | number | Date | null;
    minimumUnit?: MinimumUnit;
};

const unitScale: Record<MinimumUnit, number> = {
    minute: 60_000,
    day: 24 * 60 * 60_000,
};

export function FromNow({ date, children, minimumUnit = 'day' }: FromNowProps) {
    const locale = useResolvedLocale();

    const dateValue = date ?? children;

    if (!dateValue) {
        return null;
    }

    const laterDate = new Date(dateValue);
    const earlierDate = new Date();

    const intervalMs = laterDate.getTime() - earlierDate.getTime();
    const scale = unitScale[minimumUnit];

    const result = intlFormatDistance(laterDate, earlierDate, {
        locale: locale,
        numeric: 'auto',
        unit: Math.trunc(intervalMs / scale) === 0 ? minimumUnit : undefined,
    });

    return capitalize(result);
}
